import { LEAD_STATUS_COLOR, RATING_COLOR, QUOTE_STATUS_COLOR, SLA_STATE_COLOR, SAMPLE_STATUS_COLOR, divisionMeta } from "@/lib/constants";

export function StatusBadge({ kind = "lead", value, testid }) {
  let c = { bg: "#F3F4F6", text: "#374151", dot: null };
  let label = value;
  if (kind === "lead") c = LEAD_STATUS_COLOR[value] || c;
  else if (kind === "rating") c = RATING_COLOR[value] || c;
  else if (kind === "sample") c = SAMPLE_STATUS_COLOR[value] || c;
  else if (kind === "sla") {
    c = SLA_STATE_COLOR[value] || c;
    label = c.label || value;
  }
  else if (kind === "quote") {
    c = QUOTE_STATUS_COLOR[value] || c;
    label = (value || "").replace(/_/g, " ");
  }
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize whitespace-nowrap"
      style={{ backgroundColor: c.bg, color: c.text }}
    >
      {c.dot && <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: c.dot }} />}
      {label}
    </span>
  );
}

export function DivisionTag({ id, size = "sm" }) {
  const m = divisionMeta(id);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm"}`}
      style={{ backgroundColor: m.soft, color: m.text }}
      data-testid={`division-tag-${id || "all"}`}
    >
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: m.primary }} />
      {m.name}
    </span>
  );
}
